module.exports = __webpack_public_path__ + "img/sketch-square.b0f986b5.svg";